import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-customer-phone-modal',
  templateUrl: './customer-phone-modal.component.html',
  styleUrls: ['./customer-phone-modal.component.scss'],
})
export class CustomerPhoneModalComponent {
  @Input() user: any;

  form: FormGroup;
  errorMessage = '';
  loading = false;

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private httpSrvc: HttpService
  ) {
    this.form = this.fb.group({
      phone: ['', Validators.required],
    });
  }

  ngOnInit() {
    if (this.user?.phone) {
      const p = (this.user.phone + '').replace(/\D/g, '');
      if (p.length >= 10) {
        const ddd = p.length === 11 ? p.slice(0, 2) : p.slice(0, 2);
        const rest = p.slice(2);
        const formatted = rest.length === 9
          ? `(${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`
          : `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
        this.form.patchValue({ phone: formatted });
      }
    }
  }

  async submit() {
    this.errorMessage = '';
    const raw = (this.form.get('phone')?.value || '').toString().replace(/\D/g, '');
    const digits = raw.startsWith('55') ? raw.slice(2) : raw;
    if (digits.length < 10 || digits.length > 11) {
      this.errorMessage = 'Informe um telefone válido com DDD (10 ou 11 dígitos).';
      return;
    }
    this.loading = true;
    try {
      const phoneForStorage = '55' + digits;
      this.user.phone = phoneForStorage;
      const userDBJson = localStorage.getItem('userDB');
      if (userDBJson) {
        const userDB = JSON.parse(userDBJson);
        const current = userDB.user || userDB;
        userDB.user = { ...current, phone: phoneForStorage };
        localStorage.setItem('userDB', JSON.stringify(userDB));
      }
      const opts = this.httpSrvc.getOpts();
      if (opts) {
        await this.httpSrvc.put('user/' + this.user.id, { phone: phoneForStorage }, opts).toPromise();
      }
      await this.modalCtrl.dismiss({ saved: true });
    } catch {
      this.errorMessage = 'Não foi possível salvar. Tente novamente.';
    }
    this.loading = false;
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
